import layout from './layout';
import notification from './notification';
import password from './password';
import motDePasse from './motDePasse';
import adresseEmail from './adresseEmail';
import confirmFileDialog from './confirmFileDialog';
import confirmEmailDialog from './confirmEmailDialog';
import authentification from './authentification';
import questionnaire from './questionnaire';

export default {
	layout,
	notification,
	password,
	motDePasse,
	adresseEmail,
	confirmFileDialog,
	confirmEmailDialog,
	authentification,
	questionnaire
};
